module.exports = __webpack_public_path__ + "static/media/net.79c62aa2.png";